import { render, staticRenderFns } from "./CustomerDetail.vue?vue&type=template&id=865265d0&scoped=true&"
import script from "./CustomerDetail.vue?vue&type=script&lang=js&"
export * from "./CustomerDetail.vue?vue&type=script&lang=js&"
import style0 from "./CustomerDetail.vue?vue&type=style&index=0&id=865265d0&prod&lang=css&"
import style1 from "./CustomerDetail.vue?vue&type=style&index=1&id=865265d0&prod&lang=scss&"
import style2 from "./CustomerDetail.vue?vue&type=style&index=2&id=865265d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "865265d0",
  null
  
)

export default component.exports